import { render, staticRenderFns } from "./PointCouponIndex.vue?vue&type=template&id=7cb55f14&scoped=true&"
import script from "./PointCouponIndex.vue?vue&type=script&lang=js&"
export * from "./PointCouponIndex.vue?vue&type=script&lang=js&"
import style0 from "./PointCouponIndex.vue?vue&type=style&index=0&id=7cb55f14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb55f14",
  null
  
)

export default component.exports